// extracted by mini-css-extract-plugin
export default {"wrapper":"wp-z","response":"xp-z","error":"yp-z","disabled":"zp-z","buttons":"Ap-z","feedbackQuestionSection":"Bp-z","yesNoWrapper":"Cp-z"};